import { SHA256, enc } from 'crypto-js';

export const toSHA256 = (valueToHash: string | undefined): string | undefined => {
    const hashSha256 = (valueToHash: string) => {
        const hashedValue = SHA256(valueToHash).toString(enc.Hex);
        return hashedValue;
    };

    if (valueToHash) {
        return hashSha256(valueToHash);
    }
    return undefined;
}